/**
 * Serviço de autenticação
 * Funções para login, registro e logout
 */

import api from './api';

/**
 * Realiza o login do usuário
 */
export const login = async (email, senha) => {
  console.log('🔷 [authService] login() chamado');
  console.log('📧 Email:', email);
  console.log('🌐 URL da API:', 'POST /auth/login');
  
  try {
    const response = await api.post('/auth/login', { email, senha });
    console.log('✅ [authService] Resposta recebida:', response);
    return response;
  } catch (error) {
    console.error('❌ [authService] Erro na requisição:', error);
    throw error;
  }
};

/**
 * Registra um novo usuário
 */
export const register = async (dadosUsuario) => {
  const response = await api.post('/auth/register', dadosUsuario);
  return response;
};

/**
 * Faz logout do usuário
 */
export const logout = async () => {
  const response = await api.post('/auth/logout');
  return response;
};

/**
 * Busca dados do usuário autenticado
 */
export const getMe = async () => {
  const response = await api.get('/auth/me');
  return response;
};
